import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import { generateBranchLink } from 'service/branchService';

const RED = '#e53935';

// Small CTA shown in the Premium sidebar slot for free-plan businesses.
// Deliberately lightweight — the actual plan comparison UI lives in
// Account's MembershipModal; this just points people there.
const UpgradeToPremiumCard = ({ onUpgradeClick, code, businessName }) => {
  const [branchLink, setBranchLink] = useState('');

  useEffect(() => {
    let cancelled = false;
console.log('UpgradeToPremiumCard props:', { code, businessName });
    const createBranchLink = async () => {
      try {
        const link = await generateBranchLink(code, businessName);
        if (!cancelled && link) {
          setBranchLink(link);
        } else if (!cancelled) {
          console.error('Branch link is undefined or null.');
        }
      } catch (error) {
        console.error('Error generating branch link for UpgradeToPremiumCard:', error);
      }
    };

    if (code) {
      createBranchLink();
    }

    return () => { cancelled = true; };
  }, [code, businessName]);

  return (
    <div
      style={{
        background: `linear-gradient(135deg, ${RED} 0%, #b71c1c 100%)`,
        borderRadius: 16,
        padding: 20,
        color: '#fff',
        position: 'relative',
        overflow: 'hidden',
        marginBottom: 16,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -20,
          right: -20,
          width: 100,
          height: 100,
          background: 'rgba(255,255,255,0.08)',
          borderRadius: '50%',
        }}
      />

      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 12,
        }}
      >
        <div>
          <div style={{ fontSize: 22, marginBottom: 4 }}>👑</div>
          <div style={{ fontSize: 16, fontWeight: 800 }}>Go Premium</div>
        </div>

        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 10,
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            overflow: 'hidden',
          }}
        >
          {branchLink ? (
            <QRCodeSVG value={branchLink} size={48} />
          ) : (
            <span style={{ color: RED, fontSize: 8, textAlign: 'center', lineHeight: 1.2 }}>
              QR…
            </span>
          )}
        </div>
      </div>

      <p
        style={{
          fontSize: 12,
          color: 'rgba(255,255,255,0.85)',
          margin: '12px 0 14px',
          lineHeight: 1.5,
          textAlign: 'center',
        }}
      >
        Unlock more active coupons, AI-powered image generation, and priority support.
      </p>

      <button
        type="button"
        onClick={onUpgradeClick}
        style={{
          width: '100%',
          padding: '9px 0',
          borderRadius: 999,
          border: 'none',
          background: '#fff',
          color: RED,
          fontSize: 13,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Upgrade
      </button>
    </div>
  );
};

UpgradeToPremiumCard.propTypes = {
  onUpgradeClick: PropTypes.func.isRequired,
  code: PropTypes.string,
  businessName: PropTypes.string,
};

export default UpgradeToPremiumCard;